import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import {
    Button, CircularProgress, makeStyles
} from '@material-ui/core';
import { useForm } from 'react-hook-form';
import classNames from 'classnames';
import CheckUserProvider from '../../../AllHooks/CheckUserProvider';
import CustomAlert from '../../CustomAlert';
import mapValues from 'lodash/mapValues';
import { Helmet } from 'react-helmet';
import { getTeamDocumentWithUniqueId, updateTeamDocument } from '../../../Backend/firebase/team';

const useStyles = makeStyles((theme) => ({
    root: {

        '& .MuiFormControlLabel-label.Mui-disabled': {
            color: 'white'
        }
    },
}));

function UpdateTeam({ _id, memberId, setOpenPopup, refreshData }) {
    const classes = useStyles();
    const { register, handleSubmit, errors, reset, setValue } = useForm();
    const [openNotify, setOpenNotify] = useState(false);
    const [notificationMessage, setNotificationMessage] = useState('');
    const [alertType, setAlertType] = useState('');
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false);
    const { userData } = CheckUserProvider();

    useEffect(async () => {
        try {
            const getProducts = await getTeamDocumentWithUniqueId(memberId);
            setTimeout(() => {
                mapValues(getProducts[0], (value, key) => setValue(key, value));
            });
        } catch(error) {
            console.log("Error Occur in Update Product", error)
        }
    }, []);


    const onSubmit = async (data) => {
        setIsLoading(true);
        var newMember = {};
        newMember._id = _id;
        newMember.uniqueId = memberId;
        newMember.userId = userData.uid;
        newMember.MemberName = data.MemberName;
        newMember.Department = data.Department;
        newMember.Role = data.Role;
        try {
            var member = updateTeamDocument(newMember);
            if (member) {
                setOpenPopup(false);
                setNotificationMessage('Member Updated successfully.');
                setOpenNotify(true);
                setAlertType('success');
                setIsLoading(false);
                refreshData()
                // setTimeout(routeToPages, 2000);
            } else {
                setNotificationMessage('Something went wrong, Please try again later!!');
                setOpenNotify(true);
                setAlertType('error');
                setIsLoading(false);
                history.push('/retailer/add-member');
            }
        }  catch (error) {
            console.error(error);
            setNotificationMessage('Something went wrong, Please try again later!!');
            setOpenNotify(true);
            setAlertType('error');
            setIsLoading(false);
            history.push('/retailer/add-member');
        }
    };

    const routeToPages = () => {
        history.push('/retailer/my-team');
    }

    return (
        <>
            <div className={classes.root}>
                <Helmet>
                    <meta name="description" content="Use this page to update Member." />
                    <title>Update Member | Kaipsool Pharmatech</title>
                </Helmet>
                <div className="updateProduct">
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="row">
                            {/* <h5>Basic Details</h5> */}
                            <div className="col-md-6 mb-2">
                                Member Name <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <input type="text" className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.MemberName })}
                                    name="MemberName" autoComplete="none"
                                    ref={register({ required: 'Please enter Member Name!' })} />
                                <small className="form-text text-danger">{errors.MemberName && errors.MemberName.message}</small>
                            </div>
                            <div className="col-md-6 mb-2">
                                Member Email <span className="text-danger" style={{ fontSize: '18px', fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <input type="email" className={classNames("form-control registerEmp__textbox", { "is-invalid": errors.MemberEmail })}
                                    name="MemberEmail" 
                                    autoComplete="none"
                                    disabled={true}
                                    ref={register({ required: 'Please enter Member Email!' })} />
                                <small className="form-text text-danger">{errors.MemberEmail && errors.MemberEmail.message}</small>
                            </div>
                            <div className="col-md-6 mb-2">
                                Department
                                <input type="text" 
                                    className={classNames("form-control registerEmp__textbox")}
                                    name="Department" 
                                    autoComplete="none"
                                    ref={register()} />
                            </div>
                            <div className="col-md-6 mb-2">
                                Role <span className="text-danger" style={{ fontWeight: '900', marginLeft: '3px' }}>*</span>
                                <select
                                    className={classNames("form-select registerEmp__textbox", { "is-invalid": errors.Role })} 
                                    aria-label="Default select example"
                                    name="Role" ref={register({
                                        required: 'Please select Role!',
                                        validate: {
                                            defaultValue: value => value !== "Select Option" || 'Please select Role!'
                                        }
                                    })} defaultValue="Select Role" >
                                    <option value={'Sales Team'}>{'Sales Team'}</option>
                                    <option value={'Purchase Team'}>{'Purchase Team'}</option>
                                    <option value={'Stockist'}>{'Stockist'}</option>
                                </select>
                                <small className="form-text text-danger">{errors.Role && errors.Role.message}</small>
                            </div>
                            <div className="col-sm-12 text-right mt-2">
                                <div className="d-flex justify-content-center">
                                    <div className="p-2">
                                        <Button type="submit" variant="contained" className="registerEmp__btnLogin">
                                            {isLoading ? <CircularProgress size={18} /> : 'Update Member'}
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <CustomAlert setOpenNotify={setOpenNotify} openNotify={openNotify} messageType={alertType}
                notificationMessage={notificationMessage} />
        </>
    )
}

export default UpdateTeam
